import { Heading } from "@/components/typography/Heading";
import { Button } from "@/components/ui/button";
import type { SharedPageProps } from "@/types/models";
import { usePage } from "@inertiajs/react";

export function PromotionSection() {
  const promotions = (usePage<SharedPageProps>().props.promotions ?? []).filter((item) => item.enabled);
  if (!promotions.length) {
    return null;
  }

  return (
    <section className="px-4 py-6" aria-label="العروض">
      <div className="mx-auto grid max-w-2xl grid-cols-2 items-end gap-3 sm:gap-5">
        {promotions.map((promotion) => (
          <article
            key={promotion.id ?? promotion.image_url}
            className="min-w-0 rounded-2xl border border-stone-200 bg-stone-50 p-2 sm:p-3"
          >
            <Heading level={2} size="section" className="sr-only">
              {promotion.title}
            </Heading>
            <img
              src={promotion.image_url}
              alt={promotion.title}
              className="aspect-[3/4] max-h-[44svh] w-full rounded-lg object-contain"
              loading="lazy"
            />
            <Button
              asChild
              className="mt-3 h-auto min-h-11 w-full bg-green-700 px-2 text-xs whitespace-normal text-white hover:bg-green-800 sm:text-sm"
            >
              <a href={promotion.cta.url}>{promotion.cta.label}</a>
            </Button>
          </article>
        ))}
      </div>
    </section>
  );
}
